var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_html.js
// module id = RPLV
// module chunks = 61 62 63 64 65 66 67 68 69 70 71 72 73 74 75